import Subheading from "./Subheading";

interface SectionHeadingProps {
  text: string;
  subtitle?: string;
  subtitleClassName?: string;
  /** Use when content appears above the heading (e.g. back links) */
  compact?: boolean;
}

function SectionHeading({
  text,
  subtitle,
  subtitleClassName = "",
  compact = false,
}: SectionHeadingProps) {
  return (
    <div className="pb-8 text-center tablet:pb-12">
      <h2
        className={`font-bold text-2xl tracking-wider tablet:text-4xl ${
          compact ? "pt-0" : "pt-4 tablet:pt-16"
        }`}
      >
        {text}
      </h2>
      {subtitle && (
        <Subheading
          text={subtitle}
          className={`mx-auto mt-4 max-w-2xl px-6 text-base leading-relaxed text-neutral-600 dark:text-neutral-400 tablet:mt-6 tablet:text-lg ${subtitleClassName}`}
        />
      )}
    </div>
  );
}

export default SectionHeading;
